
    <spaq-register-code [error]="error$ | async"
                        [pending]="pending$ | async"
                        [codeForm]="codeForm$ | async"
                        (onSubmit)="onSubmit($event)"></spaq-register-code>
  


// WEBPACK FOOTER //
// /home/epoirier/PhpstormProjects/spaq-mobile/src/app/auth/register/containers/register-code-page.component.ts.RegisterCodePageComponent.html